module.exports = __webpack_public_path__ + "img/eda.fc4b09ff.png";